
import React from 'react';
import Parser from 'html-react-parser';
import styled from 'styled-components'

const TextBlock = styled.div`
    margin: 0;
    padding: 0;
`;

const Speaker = styled.p`
    font-size: 12px;
    color: #000000;
    font-weight: bold;
    margin: 0 0 5px 0;
`;

const Korero = styled.p`
    font-size: 12px;
    margin: 0;
    padding: 0;
    line-height: 1.5;
`;

const KoreroText = ({ speaker, korero }) => {
    return (
        <TextBlock>
            <Speaker>{speaker}</Speaker>
            <Korero>{Parser(korero)}</Korero>
        </TextBlock>
    )
}

export default KoreroText;